module.exports = __webpack_public_path__ + "static/media/chip.f170292b.jpg";